export default "__VITE_ASSET__CY$bw8$k__"